import script from "./loadingCards.vue?vue&type=script&setup=true&lang=js"
export * from "./loadingCards.vue?vue&type=script&setup=true&lang=js"

import "./loadingCards.vue?vue&type=style&index=0&id=4ea7c4dc&lang=css"

const __exports__ = script;

export default __exports__